// Tickets feature — query-key gyár + a lista-szűrő típusa. A tényleges hívásokat a route a tipizált
// ts-rest kliensen (`api.tickets.*`) intézi; a kulcsok itt élnek (cache-egységesítés). A `@atlas/contracts`
// a szerződés forrás-igazsága — itt csak kulcs-logika van (a clients/accounts feature-mintára).

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-/rendezés-váltás új cache-bejegyzést nyit).
 *  A `sort` a rendezés-KULCS (subject | accountName | createdAt | assigneeName …), az `order` az irány;
 *  a `q`/`status`/`type` a toolbar-szűrők. */
export interface TicketListFilters {
  q: string;
  status: string;
  type: string;
  sort: string;
  order: 'asc' | 'desc';
}

/** Query-kulcs gyár — a lista/detail/komment/csatolmány cache egységes címzése (invalidálás + optimista írás). */
export const ticketKeys = {
  all: ['tickets'] as const,
  lists: () => ['tickets', 'list'] as const,
  list: (filters: TicketListFilters) => ['tickets', 'list', filters] as const,
  detail: (id: string) => ['tickets', 'detail', id] as const,
  comments: (id: string) => ['tickets', 'comments', id] as const,
  attachments: (id: string) => ['tickets', 'attachments', id] as const,
};

/** Komment-sablon (SHARED katalógus) cache-kulcsok — globális lista (nincs per-ticket scope). */
export const templateKeys = {
  all: ['ticket-comment-templates'] as const,
  list: () => ['ticket-comment-templates', 'list'] as const,
};
